import axios from "../plugins/axios";

const defaultIncludes = [
  "customer",
  "creator",
  "finisher",
  "users",
  "departments",
  "product_labels",
  "taskable",
  "attachables",
  "attachables.child_instance",
  "automation_result.automation",
  "automation_result.global_automation_configuration",
];

const templatesIncludes = [
  "templates.users",
  "templates.departments",
  "templates.product_labels",
];

const baseUrl = "/web_api/v1/task";

export default {
  getInitialEditPageData(taskId) {
    return axios.get(`${baseUrl}/edit_page/${taskId}`, {
      params: {
        include: templatesIncludes,
      },
    })
      .then((response) => response.data);
  },
  getInitialCreatePageData(category) {
    return axios.get(`${baseUrl}/create_page/${category}`, {
      params: {
        include: templatesIncludes,
      },
    })
      .then((response) => response.data);
  },
  getById(taskId, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/${taskId}`, {
      params: {
        include,
      },
    })
      .then((response) => response.data);
  },
  getTasksByFilter(filter) {
    return axios.get(`${baseUrl}/filtered`, {
      params: filter,
    })
      .then((response) => response.data);
  },
  getActiveByCustomerId(customerId, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/active/by_customer/${customerId}`, {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getActiveByCustomerIds(customerIds, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.post(`${baseUrl}/active/by_customers`, {
      customerIds,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getActiveByInstance(instance, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.post(`${baseUrl}/active/by_instance`, {
      instanceId: instance.id,
      instanceClass: instance.class,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getActiveByCustomerIdsAndCategory(
    customerIds,
    category,
    interval,
    page,
    perPage,
    includesParam = null,
  ) {
    const include = includesParam || defaultIncludes;

    return axios.post(`${baseUrl}/active/by_customers_and_category`, {
      customerIds,
      category,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getActiveByDepartmentId(departmentId, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/active/by_department/${departmentId}`, {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getActiveByDepartmentAndProductLabels(
    departmentId, labelIds, interval, page, perPage, includesParam = null,
  ) {
    const include = includesParam || defaultIncludes;

    return axios.post(`${baseUrl}/active/by_department_and_product_labels/`, {
      department_id: departmentId,
      product_labels: labelIds,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getActiveCallbackByDepartmentId(
    departmentId, interval, page, perPage, includesParam = null,
  ) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/active_callback/by_department/${departmentId}`, {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getActiveCallbackByDepartmentAndProductLabels(
    departmentId, labelIds, interval, page, perPage, includesParam = null,
  ) {
    const include = includesParam || defaultIncludes;

    return axios.post(`${baseUrl}/active_callback/by_department_and_product_labels/`, {
      department_id: departmentId,
      product_labels: labelIds,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getActiveByUserId(userId, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/active/by_user/${userId}`, {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getActiveByUserAndProductLabels(userId, labelIds, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.post(`${baseUrl}/active/by_user_and_product_labels/`, {
      user_id: userId,
      product_labels: labelIds,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getActiveCallbackByUserId(userId, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/active_callback/by_user/${userId}`, {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getActiveCallbackByUserAndProductLabels(
    userId, labelIds, interval, page, perPage, includesParam = null,
  ) {
    const include = includesParam || defaultIncludes;

    return axios.post(`${baseUrl}/active_callback/by_user_and_product_labels/`, {
      user_id: userId,
      product_labels: labelIds,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getActive(interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/active`, {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getCompletedByCustomerId(customerId, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/completed/by_customer/${customerId}`, {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getCompletedByCustomerIds(customerIds, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.post(`${baseUrl}/completed/by_customers`, {
      customerIds,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getCompletedByInstance(instance, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.post(`${baseUrl}/completed/by_instance`, {
      instanceId: instance.id,
      instanceClass: instance.class,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getCompletedByCustomerIdsAndCategory(
    customerIds, category, interval, page, perPage, includesParam = null,
  ) {
    const include = includesParam || defaultIncludes;

    return axios.post(`${baseUrl}/completed/by_customers_and_category`, {
      customerIds,
      category,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getCompletedByDepartmentId(departmentId, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/completed/by_department/${departmentId}`, {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getCompletedByDepartmentAndProductLabels(
    departmentId, labelIds, interval, page, perPage, includesParam = null,
  ) {
    const include = includesParam || defaultIncludes;

    return axios.post(`${baseUrl}/completed/by_department_and_product_labels/`, {
      department_id: departmentId,
      product_labels: labelIds,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getCompletedCallbackByDepartmentId(departmentId, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/completed_callback/by_department/${departmentId}`, {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  // getCompletedCallbackByDepartmentAndProductLabels(
  //   departmentId,
  //   labelIds,
  //   interval,
  //   page,
  //   perPage
  // ) {
  //   return axios.post(`${baseUrl}/completed_callback/by_department_and_product_labels/`, {
  //     user_id: userId,
  //     product_labels: labelIds,
  //   },
  //   {
  //     params: {
  //       interval,
  //       page,
  //       perPage,
  //     },
  //   }).then((response) => response.data);
  // },
  getCompletedByUserId(userId, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/completed/by_user/${userId}`, {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getCompletedByUserAndProductLabels(
    userId, labelIds, interval, page, perPage, includesParam = null,
  ) {
    const include = includesParam || defaultIncludes;

    return axios.post(`${baseUrl}/completed/by_user_and_product_labels/`, {
      user_id: userId,
      product_labels: labelIds,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getCompletedCallbackByUserId(userId, interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/completed_callback/by_user/${userId}`, {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getCompletedCallbackByUserAndProductLabels(
    userId, labelIds, interval, page, perPage, includesParam = null,
  ) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/completed_callback/by_user_and_product_labels/`, {
      user_id: userId,
      product_labels: labelIds,
    },
    {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  getCompleted(interval, page, perPage, includesParam = null) {
    const include = includesParam || defaultIncludes;

    return axios.get(`${baseUrl}/completed`, {
      params: {
        interval,
        page,
        perPage,
        include,
      },
    })
      .then((response) => response.data);
  },
  completeTask(taskId, userId, interval) {
    return axios.put(`${baseUrl}/${taskId}/complete`, {
      userId,
      interval,
    })
      .then((response) => response.data);
  },
  completeTasks(taskIds, userId, interval) {
    return axios.put(`${baseUrl}/complete`, {
      taskIds,
      userId,
      interval,
    })
      .then((response) => response.data);
  },
  activateTask(taskId, userId, interval) {
    return axios.put(`${baseUrl}/${taskId}/activate`, {
      userId,
      interval,
    })
      .then((response) => response.data);
  },
  activateTasks(taskIds, userId, interval) {
    return axios.put(`${baseUrl}/activate`, {
      taskIds,
      userId,
      interval,
    })
      .then((response) => response.data);
  },
  store(task) {
    return axios.post(`${baseUrl}/`, task)
      .then((response) => response.data);
  },
  update(task) {
    return axios.put(`${baseUrl}/${task.id}`, task)
      .then((response) => response.data);
  },
  delete(id) {
    return axios.delete(`${baseUrl}/${id}`)
      .then((response) => response.data);
  },
  updateDate(task) {
    return axios.put(`${baseUrl}/${task.id}/date`, task)
      .then((response) => response.data);
  },
  updateName(task) {
    return axios.put(`${baseUrl}/${task.id}/name`, task)
      .then((response) => response.data);
  },
  getActiveTasksCountByInstance(instanceId, instanceClass) {
    return axios.post(`${baseUrl}/active/count_by_instance`, {
      instance: {
        id: instanceId,
        class: instanceClass,
      },
    })
      .then((response) => response.data);
  },
  getActiveTasksCountByFamilyCategory(customerId, categoryId) {
    return axios.post(`${baseUrl}/active/count_by_family_category`, {
      customer_id: customerId,
      category: categoryId,
    })
      .then((response) => response.data);
  },
};
